// extracted by mini-css-extract-plugin
export var arrowDown = "button-module--arrowDown--224f5";
export var arrowLeft = "button-module--arrowLeft--92d3f";
export var arrowRight = "button-module--arrowRight--1b198";
export var base = "button-module--base--3ee95";
export var circle = "button-module--circle--78740";
export var circleNext = "button-module--circleNext--870a6";
export var circlePrev = "button-module--circlePrev--32ba8";
export var clearButton = "button-module--clearButton--5a98d";
export var main = "button-module--main--d8bef";
export var play = "button-module--play--2b567";
export var plus = "button-module--plus--57daa";
export var secondary = "button-module--secondary--53813";
export var tertiary = "button-module--tertiary--643eb";
export var text = "button-module--text--2b120";
export var textButton = "button-module--textButton--f184d";